// Official content for Sila Meži website

export const companyInfo = {
  name: "Sila Meži",
  legalName: "SIA \"Sila meži\"",
  slogan: "Ilgtspējīga meža apsaimniekošana",
  phone: "+371 29555499",
  email: "info@silamezs.lv",
  regNumber: "40203362243",
  pvnNumber: "LV40203362243",
  address: "\"Straumēni 1\" - 7, Zaķumuiža, Ropažu pag., Ropažu nov., LV-2133",
  bankAccount: "LV76PARX0027325850001",
  bank: "AS \"Citadele Banka\"",
  bankCode: "PARXLV22",
  workingHours: "P-Pk: 8:00 - 18:00",
  logo: {
    transparent: "https://customer-assets.emergentagent.com/job_timber-assess/artifacts/0uw2x8ti_caurspid.png",
    dark: "https://customer-assets.emergentagent.com/job_timber-assess/artifacts/4i0mlusl_caurspid_melns.png",
    withText: "https://customer-assets.emergentagent.com/job_timber-assess/artifacts/euu5a0tb_ar_apr-07.png",
    withTextAlt: "https://customer-assets.emergentagent.com/job_timber-assess/artifacts/eeoovxjy_ar_apr-10.png"
  }
};

export const heroData = {
  title: "Neatkarīga cirsmu vērtēšana meža īpašniekiem",
  subtitle: "Palīdzam meža īpašniekiem precīzi novērtēt cirsmas vērtību un sagatavot mežu ciršanai, nodrošinot profesionālus uzmērījumus un visu nepieciešamo dokumentāciju.",
  description: "Strādājam tikai meža īpašnieka interesēs – nepērkam cirsmas un neesam saistīti ar koksnes pircējiem.",
  workIntro: "Ko mēs veicam",
  workItems: [
    "Augošu koku dastošanu",
    "Caurmēra mērīšanu",
    "Cirsmas stigošanu",
    "Īpašuma robežu un robežzīmju atjaunošanu",
    "Dokumentācijas sagatavošanu un iesniegšanu institūcijām"
  ],
  workNote: "Pilns darbu saraksts pieejams sadaļā “Darbi”.",
  reasonsTitle: "Kāpēc izvēlēties mūs",
  reasons: [
    "Precīzi meža uzmērījumi",
    "Neatkarīgs cirsmu novērtējums",
    "Korekta dokumentācija",
    "Pilnīga darba procesa caurspīdība"
  ],
  closing: "Klienti var tiešsaistē sekot līdzi darbu izpildei no jebkuras vietas.",
  tagline: "Sazinieties ar mums, lai saņemtu profesionālu attieksmi!",
  ctaPrimary: "Pieteikt cirsmas vērtēšanu",
  ctaSecondary: "Klientu portāls"
};

export const trustBadges = [
  {
    id: 1,
    title: "Precīzi meža uzmērījumi",
    description: "Detalizēti lauka mērījumi un analīze"
  },
  {
    id: 2,
    title: "Neatkarīgs cirsmu novērtējums",
    description: "Bez interesēm koksnes pirkšanā"
  },
  {
    id: 3,
    title: "Korekta dokumentācija",
    description: "Pilns sagatavošanas un iesniegšanas atbalsts"
  },
  {
    id: 4,
    title: "Pilnīga caurspīdība",
    description: "Klienti seko līdzi darbam tiešsaistē"
  }
];

export const services = [
  {
    id: 1,
    category: "Meža un cirsmu vērtēšana",
    description: "Veicam profesionālu augošu koku un cirsmu vērtēšanu, balstoties uz detalizētiem lauka mērījumiem, aktuālajām tirgus cenām un spēkā esošajiem normatīvajiem aktiem. Vērtējums tiek sagatavots neatkarīgi no cirsmas pirkšanas, tādējādi nodrošinot objektīvu un uzticamu informāciju meža īpašniekam.",
    items: [
      "Augošu koku dastošana",
      "Koku caurmēra un citu parametru mērījumi",
      "Cirsmas vērtības aprēķins un analīze"
    ],
    icon: "TreePine"
  },
  {
    id: 2,
    category: "Meža uzmērīšana un robežu darbi",
    description: "Nodrošinām dažādus meža uzmērīšanas darbus un īpašuma robežu precizēšanu dabā. Visi darbi tiek veikti, balstoties uz kadastrālajiem datiem un atbilstoši spēkā esošajiem normatīvajiem aktiem. Precīzi uzmērījumi palīdz izvairīties no robežstrīdiem un nodrošina korektu meža apsaimniekošanu.",
    items: [
      "Cirsmas stigošana",
      "Īpašuma robežu atjaunošana dabā",
      "Robežzīmju uzstādīšana un atjaunošana"
    ],
    icon: "Ruler"
  },
  {
    id: 3,
    category: "Meža atjaunošana un jaunaudžu kopšana",
    description: "Palīdzam meža īpašniekiem nodrošināt ilgtspējīgu meža attīstību, organizējot meža atjaunošanas un jaunaudžu kopšanas darbus. Pareiza kopšana agrīnajos meža attīstības posmos būtiski ietekmē meža kvalitāti un nākotnes vērtību.",
    items: [
      "Meža atjaunošanas darbu organizēšana",
      "Stādīšanas darbu plānošana un koordinēšana",
      "Jaunaudžu kopšanas darbu organizēšana"
    ],
    icon: "TreePine"
  },
  {
    id: 4,
    category: "Dokumentācijas sagatavošana un saskaņojumi",
    description: "Sagatavojam un iesniedzam visu nepieciešamo dokumentāciju meža darbiem Valsts meža dienestā un citās institūcijās. Nodrošinām pilnu administratīvo atbalstu visā procesā, lai meža īpašnieki izvairītos no sarežģītas birokrātijas.",
    items: [
      "Dokumentu sagatavošana valsts institūcijām",
      "Iesniegumu sagatavošana un iesniegšana",
      "Pilns administratīvā procesa atbalsts"
    ],
    icon: "FileText"
  },
  {
    id: 5,
    category: "Eiropas Savienības atbalsta projekti",
    description: "Konsultējam meža īpašniekus par pieejamajiem Eiropas Savienības atbalsta instrumentiem mežsaimniecībā. Nodrošinām pilnu projekta sagatavošanas un administrēšanas procesu — no idejas līdz projekta realizācijai.",
    items: [
      "Konsultācijas par ES atbalsta iespējām",
      "Projektu dokumentācijas sagatavošana",
      "Projektu iesniegšana un uzraudzība"
    ],
    icon: "Award"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Pieteikums",
    description: "Klients sazinās ar mums, lai pieteiktu cirsmas vērtēšanu vai citu pakalpojumu."
  },
  {
    id: 2,
    title: "Īpašuma apsekošana",
    description: "Veicam īpašuma apmeklējumu un nepieciešamos lauka darbus."
  },
  {
    id: 3,
    title: "Mērījumi un vērtēšana",
    description: "Precīzi uzmērām mežaudzi un sagatavojam objektīvu vērtējumu."
  },
  {
    id: 4,
    title: "Dokumentācijas sagatavošana",
    description: "Sagatavojam un iesniedzam nepieciešamos dokumentus valsts institūcijām."
  },
  {
    id: 5,
    title: "Darbu uzraudzība tiešsaistē",
    description: "Klients var sekot līdzi darbu izpildei klientu portālā."
  },
  {
    id: 6,
    title: "Noslēguma atskaite",
    description: "Sniedzam pārskatāmu atskaiti par paveiktajiem darbiem un rezultātiem."
  }
];

export const portalData = {
  title: "Digitālā platforma – Klientu portāls",
  description: "Mūsu klientiem piedāvājam ērtu un drošu tiešsaistes klientu portālu, kas nodrošina nepārtrauktu piekļuvi informācijai par projekta vai darbu gaitu. Portāls ļauj vienuviet pārskatīt aktuālo informāciju, sekot darbu statusam un piekļūt visiem ar projektu saistītajiem dokumentiem.",
  subtitle: "Platforma ir izstrādāta, lai nodrošinātu maksimālu pārskatāmību un ērtu komunikāciju starp klientu un mūsu komandu. Klienti jebkurā brīdī var redzēt aktuālo situāciju bez nepieciešamības sazināties papildus. Portāls ir pieejams gan no datora, gan mobilajām ierīcēm, tādējādi nodrošinot piekļuvi informācijai jebkurā vietā un laikā.",
  featuresTitle: "Galvenās funkcijas"
};

export const portalFeatures = [
  {
    id: 1,
    title: "Darbu statuss",
    description: "Sekojiet līdzi projekta vai darbu progresam reāllaikā – redziet, vai darbi ir plānoti, procesā vai pabeigti.",
    icon: "Activity"
  },
  {
    id: 2,
    title: "Dokumentu pieejamība",
    description: "Visi ar projektu saistītie dokumenti pieejami vienuviet. Tos iespējams apskatīt un lejupielādēt jebkurā laikā.",
    icon: "FolderOpen"
  },
  {
    id: 3,
    title: "Paziņojumi",
    description: "Saņemiet aktuālu informāciju par projekta gaitu, izmaiņām vai svarīgiem jaunumiem.",
    icon: "Bell"
  },
  {
    id: 4,
    title: "Pieejams jebkur",
    description: "Portāls darbojas gan datorā, gan mobilajās ierīcēs, nodrošinot ērtu piekļuvi neatkarīgi no atrašanās vietas.",
    icon: "Smartphone"
  }
];

export const worksCatalog = [
  {
    id: "mezsaimniecibas",
    title: "Mežsaimniecības darbi",
    description: "Precīzi lauka darbi un cirsmu sagatavošana drošai un korektai meža apsaimniekošanai.",
    items: [
      "Cirsmu iestigošana (stigošana)",
      "Dastošana",
      "Augošu koku atzarošana"
    ]
  },
  {
    id: "atjaunosana",
    title: "Meža atjaunošana un kopšana",
    description: "Ilgtspējīgas meža attīstības nodrošināšana ar mērķtiecīgi plānotiem atjaunošanas darbiem.",
    items: [
      "Meža atjaunošana",
      "Jaunaudžu kopšana",
      "Jaunaudžu aizsardzība pret dzīvnieku postījumiem"
    ]
  },
  {
    id: "apsaimniekosana",
    title: "Meža īpašumu apsaimniekošana",
    description: "Pilna cikla meža īpašumu pārvaldība un darbu koordinēšana no plānošanas līdz izpildei.",
    items: [
      "Meža īpašumu apsaimniekošana"
    ]
  },
  {
    id: "es",
    title: "ES projektu sagatavošana",
    description: "Konsultācijas, dokumentu sagatavošana un projektu uzraudzība ES atbalsta programmās.",
    items: [
      "Projektu iesniegšana un uzraudzība"
    ]
  }
];

export const whyIndependentData = {
  title: "Kāpēc izvēlēties neatkarīgu cirsmu vērtēšanu",
  description: "Cirsmas vērtēšana, ko veic potenciālais pircējs, vienmēr ir saistīta ar interešu konfliktu. Neatkarīga vērtēšana nodrošina objektīvu skatījumu uz cirsmas reālo vērtību un palīdz meža īpašniekam pieņemt pamatotus lēmumus.",
  conclusion: "Neatkarīgs vērtējums bieži ļauj izvairīties no finansiāli neizdevīgiem darījumiem un sniedz skaidru priekšstatu par meža īpašuma potenciālu."
};


export const whyIndependent = [
  {
    id: 1,
    title: "Kāpēc cirsmas pircējs nav objektīvs vērtētājs?",
    content: "Cirsmas pircējam ir finansiāla ieinteresētība iegādāties mežu par iespējami zemāku cenu. Tas rada interešu konfliktu, veicot vērtēšanu. Neatkarīgs vērtētājs strādā tikai jūsu interesēs."
  },
  {
    id: 2,
    title: "Kā neatkarīgs vērtējums ietekmē ienākumus?",
    content: "Precīzs un neatkarīgs vērtējums ļauj noteikt patieso cirsmas vērtību un sarunās ar pircējiem panākt godīgu cenu. Daudzi meža īpašnieki, izmantojot neatkarīgu vērtējumu, ir ieguvuši par 15-30% augstāku cenu."
  },
  {
    id: 3,
    title: "Biežāk pieļautās kļūdas",
    content: "Nepietiekama informācija par koksnes apjomiem, paļaušanās tikai uz pircēja vērtējumu, nesagatavota dokumentācija un nezināšana par tirgus cenām – tās ir biežākās kļūdas, kas samazina meža īpašnieka ienākumus."
  }
];

export const aboutData = {
  title: "Par uzņēmumu",
  description: "Mēs esam mežsaimniecības pakalpojumu sniedzējs ar specializāciju neatkarīgā cirsmu vērtēšanā un precīzos meža uzmērījumos. Strādājam saskaņā ar Latvijas Republikas normatīvajiem aktiem un ciešā sadarbībā ar valsts institūcijām.",
  mission: "Mūsu mērķis ir nodrošināt meža īpašniekiem korektu, caurspīdīgu un profesionālu pakalpojumu visā sadarbības procesā.",
  points: [
    "Specializējamies neatkarīgā cirsmu vērtēšanā",
    "Precīzi meža uzmērījumi atbilstoši normatīvajiem aktiem",
    "Cieša sadarbība ar Valsts meža dienestu",
    "Pilna dokumentācijas nodrošināšana",
    "Sadarbojamies gan ar fiziskām, gan juridiskām personām"
  ],
  regions: ["Rīga un apkārtne", "Vidzeme", "Latgale", "Kurzeme", "Zemgale"]
};

export const contactData = {
  title: "Kontakti",
  description: "Sazinieties ar mums, lai pieteiktu pakalpojumu vai saņemtu konsultāciju par Jūsu meža īpašumu.",
  formNote: "Aizpildiet pieteikuma formu, un mēs ar Jums sazināsimies."
};

export const images = {
  hero: "https://images.unsplash.com/photo-1587731234815-546d129a3b0f?w=1920&q=80",
  forestry: "https://images.unsplash.com/photo-1662013605243-e68381f78925?w=800&q=80",
  documentation: "https://images.unsplash.com/photo-1758599668244-f5fc72199313?w=800&q=80",
  measurement: "https://images.unsplash.com/photo-1626828476637-5bd713ef9f22?w=800&q=80"
};
